import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App.tsx";
import "./index.css";
import "./i18n/config";
import { ErrorLoggerProvider } from './contexts/ErrorLoggerContext';

const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ErrorLoggerProvider>
        <App />
      </ErrorLoggerProvider>
    </QueryClientProvider>
  </StrictMode>
);
